// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".countdown-wrapper[data-v-2a4f08b6]{bottom:2px;right:18px;-webkit-backdrop-filter:blur(15px);backdrop-filter:blur(15px)}.countdown-opacity-background[data-v-2a4f08b6],.countdown-wrapper[data-v-2a4f08b6]{position:absolute;border-radius:10px;background-color:#fff}.countdown-opacity-background[data-v-2a4f08b6]{opacity:.7;top:0;bottom:0;left:0;right:0}.countdown-time[data-v-2a4f08b6]{position:relative;padding:4px 8px;font-size:12px;font-weight:500;color:#7c8b91}", ""]);
// Exports
module.exports = exports;
